import deepmerge from 'deepmerge';
import hashString from 'hash-string';
import i18next from 'i18next';
import _ from 'lodash';
import { initReactI18next, Trans as _Trans } from 'react-i18next';
import { isClientContext, isServerContext } from '../globals';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
export var Site = {
    CN: 1,
    INTL: 2
};
export var Languages = {
    EN: 'en',
    KO: 'ko',
    JP: 'jp',
    ZH: 'zh',
    PT: 'pt',
    IND: 'ind'
};
export var L = Languages;
var _obj;
export var LanguageCollection = {
    list: [
        Languages.EN,
        Languages.KO,
        Languages.JP,
        Languages.ZH,
        Languages.PT,
        Languages.IND
    ],
    // list: [Languages.EN, Languages.KO, Languages.JP, Languages.ZH],
    entities: (_obj = {}, _defineProperty(_obj, L.EN, {
        id: L.EN,
        name: 'English',
        path: ''
    }), _defineProperty(_obj, L.KO, {
        id: L.KO,
        name: '한국어',
        path: '/ko'
    }), _defineProperty(_obj, L.JP, {
        id: L.JP,
        name: '日本語',
        path: '/jp'
    }), _defineProperty(_obj, L.ZH, {
        id: L.ZH,
        name: '简体中文',
        path: '/zh'
    }), _defineProperty(_obj, L.PT, {
        id: L.PT,
        name: 'Portugu\xeas',
        path: '/pt'
    }), _defineProperty(_obj, L.IND, {
        id: L.IND,
        name: 'Bahasa Indonesia',
        path: '/ind'
    }), _obj)
};
// 从句子计算哈希一个 key 值，该算法需要和 scanner 保持一致
export var hashKey = function(value) {
    if (!value) {
        return '';
    }
    return "k_".concat("0000".concat(hashString(value.replace(/\s+/g, '')).toString(36)).slice(-7));
};
export var init = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ns = ref.ns, resources = ref.resources;
    if (!isClientContext) {
        return i18next;
    }
    return i18next.use(initReactI18next).init({
        resources: deepmerge(window && window.LANG_PKG_COM || {}, resources),
        lng: runtime.language,
        fallbackLng: L.EN,
        keySeparator: false,
        ns: [
            'common'
        ].concat(ns),
        defaultNS: ns || 'common',
        fallbackNS: 'common',
        interpolation: {
            escapeValue: false
        },
        react: {
            hashTransKey: hashKey
        }
    });
};
export var getInstance = function() {
    return isServerContext ? _.get(process, 'domain.req.i18n', i18next) : i18next;
};
/**
 *	词条相关
 */ export var t = function(sentence, options) {
    var key = hashKey(sentence);
    return getInstance().t(key, _objectSpread({}, options || {}, {
        defaultValue: sentence
    }));
};
export var genI18T = function(nameSpace) {
    return function(sentence, options) {
        var key = hashKey(sentence);
        return getInstance().t("".concat(nameSpace, ":").concat(key), _objectSpread({}, options || {}, {
            defaultValue: sentence
        }));
    };
};
export var Trans = _Trans;
// @deprecated
export var createTranslator = function(param) {
    var resources = param.resources;
    return function(sentence) {
        var locale = resources || {};
        return locale[sentence] || sentence;
    };
};
/**
 * 链接相关
 */ export var removeLngPath = function(srcUrl) {
    var ref = extractUrl(srcUrl), protocal = ref.protocal, host = ref.host, path = ref.path;
    return "".concat(protocal).concat(host).concat(path);
};
/**
 * 从 url 上解析出语言属性，其中返回的 path 不带语言属性
 */ export var extractUrl = function(srcUrl) {
    var protocal;
    var host;
    var path;
    var language1;
    if (/^((?:https?:)?\/\/)([^/]+)(\/.*)?$/.test(srcUrl)) {
        protocal = RegExp.$1;
        host = RegExp.$2;
        path = RegExp.$3;
    } else {
        protocal = '';
        host = '';
        path = srcUrl;
    }
    var ref = _slicedToArray(path.split('#'), 2), tempPath = ref[0], anchor = ref[1];
    path = tempPath;
    var pathname = path.split('?')[0];
    var base = pathname.slice(1).split('/').shift() || '';
    var match = LanguageCollection.entities[base];
    if (match) {
        language1 = match.id;
        path = path.replace(new RegExp("^/".concat(language1)), '');
    } else {
        language1 = L.EN;
    }
    return {
        protocal: protocal,
        host: host,
        path: path,
        language: language1,
        anchor: anchor
    };
};
/**
 *	替换成当前语言的访问链接
 */ export var l = function(srcUrl, language2) {
    var ref = extractUrl(srcUrl), protocal = ref.protocal, host = ref.host, _language = ref.language, path = ref.path;
    language2 = language2 || runtime.language;
    if (_language === language2) {
        return srcUrl;
    }
    var pathbase = LanguageCollection.entities[language2].path;
    return "".concat(protocal).concat(host).concat(pathbase).concat(path) || '/';
};
export var runtime = {
    get language () {
        return isClientContext ? window.$locale ? window.$locale.language : Languages.EN : _.get(process, 'domain.req.language', Languages.EN);
    },
    get languagePath () {
        var language = this.language;
        return LanguageCollection.entities[language].path;
    }
};
